import { useContext, useState } from "react";
import shortid from "shortid";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../helpers";
import { Button, IconGoogle, Link } from "../../atoms";
import { Dialog } from "../Dialog";
import {
  ActionButton,
  ActionCell,
  DetailsTable,
  EmptyTable,
  EmptyTableWrapper,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Wrapper,
} from "./styles";

export interface RowContract {
  [key: string]: any | Object;
}

type TableProps = {
  data: RowContract[];
  onClick: (data: RowContract[]) => void;
  ignoreButtons: boolean;
};

export function TableTour({ data, onClick, ignoreButtons }: TableProps) {
  const { applicationData } = useContext(AuthContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [idExclusao, setIdExclusao] = useState<number | null>(null);

  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const excluir = async (id: number) => {
    const response = await api.delete(`/api/passeio/${id}`);
    if (response.data.statuscode === 200) {
      data = data.filter((item) => {
        return item.Codigo !== id;
      });
      setType("success");
      setTextAlert(response.data.message);
      setShow(true);
      onClick(data);
    }
  };

  const tableHead =
    Object.keys(data).length > 0
      ? [
          ...Object.keys(data[0]).filter((key) => key !== "Codigo"),
          ...(ignoreButtons ? [] : ["Ações"]),
        ]
      : [];

  return (
    <>
      {Object.keys(data).length > 0 ? (
        <Wrapper>
          <DetailsTable className="table table-striped">
            <TableHeader>
              <TableRow>
                {tableHead.map((columnName) =>
                  columnName === "Ações" ? (
                    <TableColumn colSpan={2} key={shortid.generate()}>
                      {columnName}
                    </TableColumn>
                  ) : (
                    <TableColumn key={shortid.generate()}>
                      {columnName}
                    </TableColumn>
                  )
                )}
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((row) => (
                <TableRow key={shortid.generate()}>
                  {Object.entries(row)
                    .filter(([key]) => key !== "Codigo")
                    .map(([key, value]) => (
                      <TableCell key={shortid.generate()}>
                        {value as React.ReactNode}
                      </TableCell>
                    ))}
                  {!ignoreButtons && (
                    <ActionCell>
                      <div>
                        <Link to={"/cadastros/passeios/" + row["Codigo"]}>
                          <ActionButton appearance="primary">Edit</ActionButton>
                        </Link>
                        <ActionButton
                          appearance="danger"
                          onClick={() => {
                            setOpenDialog(true);
                            setIdExclusao(row["Codigo"]);
                          }}
                        >
                          Exc
                        </ActionButton>
                      </div>
                    </ActionCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </DetailsTable>
        </Wrapper>
      ) : (
        <EmptyTableWrapper>
          <EmptyTable>
            <IconGoogle>error_outline</IconGoogle> Não encontramos nenhum
            registro para apresentação.
          </EmptyTable>
        </EmptyTableWrapper>
      )}

      {!ignoreButtons && (
        <Dialog
          open={openDialog}
          title="Confirmação de exclusão"
          description="Confirma exclusão do registro?"
          onShow={(action) => {
            setOpenDialog(action === "opened");
          }}
          actions={
            <>
              <Button
                appearance="success"
                autoFocus
                onClick={() => {
                  excluir(idExclusao!);
                  setOpenDialog(false);
                }}
              >
                Confirmar
              </Button>
            </>
          }
        />
      )}
    </>
  );
}
